import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Services } from '@/services/services';
import { CurrentSession } from '@/services/repository/session';
import { CleanWizardData } from './Model';

export const SupportWizard = ({ services }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()

  useEffect(() => {
      CleanWizardData()
      navigate(`/communal/support/wizard/page1`, { replace: true })
  }, [navigate]);

  return null; // No UI needed since it redirects immediately
}
